import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-11",
  "use": "menu-11-usage",
  "viewBox": "0 0 130 103",
  "content": "<symbol viewBox=\"0 0 130 103\" id=\"menu-11\"><title>资源 109</title><g id=\"menu-11_图层_2\" data-name=\"图层 2\"><g id=\"menu-11_图层_1-2\" data-name=\"图层 1\"><path d=\"M109,84.33h-9c-3.44,0-6.2-2.45-6.2-4.9V21.9a7.27,7.27,0,0,1,6.89-4.9h9c2.76,0,5.51,2.45,5.51,4.9V78.82C115.22,81.88,112.47,84.33,109,84.33Z\" /><path d=\"M67.69,84.33H59.42c-3.44,0-6.2-3.37-6.2-7.87V7.87C53.22,3.37,56,0,59.42,0h9c2.76,0,5.51,3.37,5.51,7.87V77c0,3.94-2.76,7.31-6.2,7.31Z\" /><path d=\"M18.09,84.33c-3.44,0-6.2-.88-6.2-2.21V51.21c0-1.33,2.76-2.21,6.2-2.21h9a13.86,13.86,0,0,1,4.13.88c.69.44,1.38.88,1.38,1.33V81.68c0,1.77-2.76,2.65-6.2,2.65H18.09Z\" /><rect y=\"93\" width=\"130\" height=\"10\" rx=\"5\" ry=\"5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-11.svg
// module id = 27Ve
// module chunks = 264